import { get } from 'lodash';
import { resolve, reject } from 'redux-optimist-promise';
import {
  FETCH_PROPOSALS,
  ADD_ACCOMMODATION,
  ADD_ACCOMMODATION_FROM_ALTERNATIVES,
  ADD_TRANSPORT,
  FETCH_SELECTED_PROPOSAL_PAYMENT,
  SAVE_CUSTOMER_PROPOSAL,
  FETCH_PROPOSALS_FROM_EDIT_CRITERIA,
  PROPOSAL_REFRESH,
  EDIT_HOUSEHOLDS,
} from 'Store/booking/proposals/constants';
import { START_LOADING, END_LOADING } from 'Store/global-loader/globalLoader.action';
type State = boolean;
const initialState: State = false;

function ShouldDisplayReducer(
  state: State = initialState,
  action: Action<any> | null | undefined,
): State {
  switch (get(action, 'type')) {
    case START_LOADING:
    case ADD_ACCOMMODATION:
    case ADD_ACCOMMODATION_FROM_ALTERNATIVES:
    case ADD_TRANSPORT:
    case FETCH_PROPOSALS:
    case FETCH_SELECTED_PROPOSAL_PAYMENT:
    case SAVE_CUSTOMER_PROPOSAL:
    case FETCH_PROPOSALS_FROM_EDIT_CRITERIA:
    case EDIT_HOUSEHOLDS:
      return true;

    case END_LOADING:
    case resolve(ADD_ACCOMMODATION):
    case reject(ADD_ACCOMMODATION):
    case resolve(ADD_ACCOMMODATION_FROM_ALTERNATIVES):
    case reject(ADD_ACCOMMODATION_FROM_ALTERNATIVES):
    case resolve(ADD_TRANSPORT):
    case reject(ADD_TRANSPORT):
    case reject(FETCH_PROPOSALS):
    case resolve(FETCH_SELECTED_PROPOSAL_PAYMENT):
    case reject(FETCH_SELECTED_PROPOSAL_PAYMENT):
    case resolve(SAVE_CUSTOMER_PROPOSAL):
    case reject(SAVE_CUSTOMER_PROPOSAL):
    case resolve(FETCH_PROPOSALS_FROM_EDIT_CRITERIA):
    case reject(FETCH_PROPOSALS_FROM_EDIT_CRITERIA):
    case reject(PROPOSAL_REFRESH):
    case resolve(EDIT_HOUSEHOLDS):
      return false;

    case resolve(FETCH_PROPOSALS):
      return get(action, 'payload.proposals.errors') ? false : state;

    default:
      return state;
  }
}

export default ShouldDisplayReducer;
